import { render } from "./Adspace.vue?vue&type=template&id=362d843f&scoped=true"
const script = {}

import "./Adspace.vue?vue&type=style&index=0&id=362d843f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362d843f"]])

export default __exports__